'use client'

import { createContext, type ComponentPropsWithRef, type ReactNode } from 'react'

export type LinkRenderer = (props: ComponentPropsWithRef<'a'>) => ReactNode

export type LinkProviderProps = {
  children: ReactNode
  renderLink: LinkRenderer
}

export const LinkRendererContext = createContext<LinkRenderer | null>(null)

/**
 * Supply application navigation for Link and ButtonLink. The renderer forwards native anchor attributes, refs,
 * and generated styles; applications decide which destinations their router owns. Explicit render props take
 * precedence. Status: supported.
 */
export function LinkProvider({ children, renderLink }: LinkProviderProps) {
  return <LinkRendererContext value={renderLink}>{children}</LinkRendererContext>
}
